function roundTo(x:number, decimals:number) {
	return Number(x.toFixed(decimals));
}

const Utils = {
    roundTo: roundTo
}

export default Utils;